<template>
  <button @click="$emit('click')" type="button" class="items-center px-4 py-2 border border-transparent text-base font-medium
  rounded-md shadow-sm text-brand-dark bg-brand-light hover:opacity-75 focus:outline-none focus:ring-2 focus:ring-offset-2
  focus:ring-indigo-500" v-html="text">

  </button>
</template>

<script>
import buttonMixin from "@/components/Functional/Buttons/buttonMixin";

export default {
  name: "NeutralButton",
  mixins: [buttonMixin]
}
</script>

<style scoped>

</style>